// @ts-strict-ignore
import sortBy from 'lodash/sortBy';

import {apiClient} from 'common/util/api-client';
import {DataGroup} from 'common/widgets/data-group-selector/types';

import {appApiUrl} from '../utils';
import {BaseClient} from '../utils/base-client';

class DataGroupsClient extends BaseClient<DataGroup[]> {
  addNewDataGroup({projectId, propertyName, displayName}) {
    return apiClient.post(this.buildEndpoint({projectId}), {
      display_name: displayName,
      property_name: propertyName,
    });
  }

  deleteDataGroup({projectId, dataGroupId}) {
    return apiClient.delete(this.buildEndpoint({projectId, dataGroupId}));
  }

  updateDataGroupName({projectId, dataGroupId, newDataGroupName}) {
    return apiClient.post(this.buildEndpoint({projectId, dataGroupId}), {display_name: newDataGroupName});
  }

  query(params, queryOpts = {}) {
    // Normalize input so the cache works as expected.
    // Note that each instances of DataGroupsClient creates its own cache. It should be a singleton, but currently e.g.
    // insights-app and nested mp-query-builder each instantiate an instance which can produce identical requests.
    const {projectId, workspaceId} = params;
    const normalizedParams = {
      projectId: parseInt(projectId, 10),
      workspaceId: workspaceId ? parseInt(workspaceId, 10) : 0,
    };

    return super.query(normalizedParams, queryOpts);
  }

  buildEndpoint({
    projectId,
    workspaceId,
    dataGroupId,
  }: {
    projectId: number;
    workspaceId?: number;
    dataGroupId?: number;
  }) {
    return appApiUrl(`data-groups/${dataGroupId ? `${dataGroupId}/` : ``}`, {projectId, workspaceId});
  }

  processResponse(response): DataGroup[] {
    const groups = response.results.map((dataGroup) => ({
      displayName: dataGroup.display_name,
      groupID: dataGroup.data_group_id,
      isReady: dataGroup.is_ready,
      propertyName: dataGroup.property_name,
      type: dataGroup.type,
    }));

    return sortBy(groups, `displayName`);
  }
}

export const dataGroupsClient = new DataGroupsClient();
